import { Value } from 'slate';
import { SLATE_DEFAULT_VALUE } from '../../../../store/constants/editJournalDefaultValues';

const abstractRef = {
  type: 'abstract',
  editorRef: null,
  value: Value.fromJSON(SLATE_DEFAULT_VALUE),
};

const contentRef = {
  type: 'content',
  editorRef: null,
  value: Value.fromJSON(SLATE_DEFAULT_VALUE),
};

const conclusionRef = {
  type: 'conclusion',
  editorRef: null,
  value: Value.fromJSON(SLATE_DEFAULT_VALUE),
};

export default {
  /**
   * TODO: change it to captial case if there is not conflict
   */
  mla: {
    0: { ...contentRef, minHeight: '1350px' },
    1: { ...conclusionRef, minHeight: '10rem' },
  },
  ieee: {
    0: { ...abstractRef, minHeight: '10rem' },
    1: { ...contentRef, minHeight: '1350px' },
  },
  apa: {
    0: { ...abstractRef, minHeight: '10rem' },
    1: { ...contentRef, minHeight: '1350px' },
    2: { ...conclusionRef, minHeight: '10rem' },
  },
  thesis: {
    0: {
      type: 'chapter1',
      editorRef: null,
      value: Value.fromJSON(SLATE_DEFAULT_VALUE),
    },
  },
  book: {
    0: {
      type: 'chapter1',
      sections: {
        0: {
          type: 'section1',
          editorRef: null,
          value: Value.fromJSON(SLATE_DEFAULT_VALUE),
        },
      },
    },
  },
};
